import startsWith from "lodash-es/startsWith";

import { walk } from "common/components/utils/walk";

import { DefaultModel } from "./defaultModel";
import { DefaultView } from "./defaultView";

import { QuickModel } from "./quick/quickModel";
import { QuickView } from "./quick/quickView";

import { TableModel } from "./table/tableModel";
import { TableView } from "./table/tableView";

import { PieModel } from "./pie/pieModel";
import { PieView } from "./pie/pieView";

import { TrendlineModel } from "./trendline/trendlineModel";
import { TrendlineView } from "./trendline/trendlineView";

import { MapModel } from "./map/mapModel";
import { MapView } from "./map/mapView";

import { DoublePivotModel } from "./doublePivot/doublePivotModel";
import { DoublePivotView } from "./doublePivot/doublePivotView";

import { ChargebackRateByNetworkModel } from "./custom/rateByNetwork/chargebackRateByNetworkModel";
import { ChargebackRateByNetworkView } from "./custom/rateByNetwork/chargebackRateByNetworkView";

const all = {
    "default": {
        Model: DefaultModel,
        View: DefaultView
    },
    quick: {
        Model: QuickModel,
        View: QuickView
    },
    table: {
        Model: TableModel,
        View: TableView
    },
    pie: {
        Model: PieModel,
        View: PieView
    },
    trendline: {
        Model: TrendlineModel,
        View: TrendlineView
    },
    map: {
        Model: MapModel,
        View: MapView
    },
    doublePivot: {
        Model: DoublePivotModel,
        View: DoublePivotView
    },
    custom: {
        chargebackRateByNetwork: {
            Model: ChargebackRateByNetworkModel,
            View: ChargebackRateByNetworkView
        }
    }
};

/**
 * API
 */
export const getByType = function(widgetType, klass) {
    if (!["View", "Model"].includes(klass)) {
        throw new Error(`Unknown class: ${klass}`);
    }
    
    if (startsWith(widgetType, "custom.")) {
        return walk(all, widgetType)[klass];
    }
    
    if (all[widgetType]) {
        return all[widgetType][klass];
    }
    
    return false;
};
